// Format date
export const formatDate = (dateStr) => {
  if (!dateStr) return 'N/A';
  return new Date(dateStr).toLocaleDateString('en-ZA', {
    year: 'numeric', month: 'short', day: 'numeric',
  });
};

export const formatDateTime = (dateStr) => {
  if (!dateStr) return 'N/A';
  return new Date(dateStr).toLocaleDateString('en-ZA', {
    year: 'numeric', month: 'short', day: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
};

// Format salary
export const formatSalary = (min, max, currency = 'ZAR') => {
  const fmt = (n) => new Intl.NumberFormat('en-ZA', { style: 'currency', currency, maximumFractionDigits: 0 }).format(n);
  if (min && max) return `${fmt(min)} - ${fmt(max)}`;
  if (min) return `From ${fmt(min)}`;
  if (max) return `Up to ${fmt(max)}`;
  return 'Negotiable';
};

// Truncate text
export const truncate = (text, length = 150) => {
  if (!text) return '';
  return text.length > length ? text.substring(0, length) + '...' : text;
};

// Time ago
export const timeAgo = (dateStr) => {
  if (!dateStr) return '';
  const now = new Date();
  const date = new Date(dateStr);
  const seconds = Math.floor((now - date) / 1000);
  if (seconds < 60) return 'Just now';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo ago`;
  return `${Math.floor(months / 12)}y ago`;
};

// Application status labels & colors
export const APPLICATION_STATUSES = {
  applied: { label: 'Applied', color: 'var(--accent-primary)', bg: 'rgba(59, 130, 246, 0.15)' },
  reviewing: { label: 'Reviewing', color: 'var(--accent-warning)', bg: 'rgba(245, 158, 11, 0.15)' },
  shortlisted: { label: 'Shortlisted', color: 'var(--accent-purple)', bg: 'rgba(139, 92, 246, 0.15)' },
  interview: { label: 'Interview', color: 'var(--accent-secondary)', bg: 'rgba(6, 182, 212, 0.15)' },
  offered: { label: 'Offered', color: 'var(--accent-success)', bg: 'rgba(34, 197, 94, 0.15)' },
  rejected: { label: 'Rejected', color: 'var(--accent-danger)', bg: 'rgba(239, 68, 68, 0.15)' },
  withdrawn: { label: 'Withdrawn', color: 'var(--text-muted)', bg: 'rgba(90, 113, 146, 0.15)' },
};

// Job types
export const JOB_TYPES = [
  { value: 'full-time', label: 'Full-time' },
  { value: 'part-time', label: 'Part-time' },
  { value: 'contract', label: 'Contract' },
  { value: 'freelance', label: 'Freelance' },
  { value: 'internship', label: 'Internship' },
  { value: 'temporary', label: 'Temporary' },
];

// Experience levels
export const EXPERIENCE_LEVELS = [
  { value: 'entry', label: 'Entry Level' },
  { value: 'junior', label: 'Junior' },
  { value: 'mid', label: 'Mid Level' },
  { value: 'senior', label: 'Senior' },
  { value: 'lead', label: 'Lead' },
  { value: 'manager', label: 'Manager' },
  { value: 'director', label: 'Director' },
  { value: 'executive', label: 'Executive' },
];

// Build query string from object
export const buildQuery = (params) => {
  const filtered = Object.entries(params).filter(([, v]) => v !== '' && v !== null && v !== undefined);
  return Object.fromEntries(filtered);
};

// Debounce
export const debounce = (fn, delay = 300) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
};
